<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<!-- <h1 mat-dialog-title>{{ actionCamelCase }} {{ typeCamelCase }} Details</h1> -->

<div mat-dialog-content>
	<ng-container *ngIf="type === 'section'">
		<div class="main-section-box">
			<h5 style="font-weight: 800;font-size: 17px;">{{ actionCamelCase }} {{ typeCamelCase }} Details</h5>
			<div class="fl section-name-bx">
				<mat-label class="mat-label">Section Name</mat-label>
				<input [(ngModel)]="itemCopy.name" matInput required>
			</div>

			<div class="fl section-desc-bx">
				<mat-label class="mat-label">Description</mat-label>
				<div class="desc-textarea">
					<textarea name="Description" [(ngModel)]="itemCopy.description" id="" cols="30" rows="3" required [maxlength]="300"></textarea>
					<p>{{300 - itemCopy.description.length}} characters left</p>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'unit'">
		<div class="main-top-box">
			<!-- <div class="fl" *ngIf="action === 'edit'">
				<mat-label class="mat-label">DOSE Number</mat-label>
				<input [(ngModel)]="itemCopy.dfs" matInput required [disabled]="shouldInputBeDisabled()">
			</div> -->

			<h5>{{ actionCamelCase }} {{ typeCamelCase }} Details</h5>

			<!-- <div class="fl" *ngIf="action === 'add'">
				DOSE Number will get added automatically once you save this unit.
			</div> -->

			<div class="fl">
				<mat-label class="mat-label">Unit Name</mat-label>
				<input [(ngModel)]="itemCopy.name" matInput required>
			</div>

			<div class="type-point-box">
				<div class="fl type-box">
					<mat-label class="mat-label">Unit Type</mat-label>
					<mat-select [value]="showVideoType(itemCopy.type)" (selectionChange)="newUnitChangeType($event.value)" [disabled]="shouldInputBeDisabled()">
						<mat-option *ngFor="let type of unitTypes" [value]="type">{{ type.charAt(0).toUpperCase() + type.slice(1) }}</mat-option>
					</mat-select>
				</div>

				<div class="fl point-box">
					<mat-label class="mat-label">Points</mat-label>
					<input [(ngModel)]="itemCopy.pts" matInput required>
				</div>
			</div>

			<!-- For quiz and old video type -->

			<div class="fl" *ngIf="((itemCopy.type === 'quiz' || itemCopy.type === 'Quiz') && itemCopy.quizType!=='ispring quiz') || (itemCopy.type === 'video' && itemCopy.videoType !== 'standard video') || itemCopy.type === 'videosity unit'">
				<mat-label class="mat-label">Select Category</mat-label>
				<mat-select [value]="itemCopy.categoryId" (selectionChange)="changeCategoryType($event.value)">
					<mat-option *ngFor="let cat of videosityCategories" [value]="cat.id">{{ cat.name }}</mat-option>
				</mat-select>
			</div>

			<div class="fl" *ngIf="((itemCopy.type === 'quiz' || itemCopy.type === 'Quiz') && itemCopy.quizType!=='ispring quiz') || (itemCopy.type === 'video' && itemCopy.videoType !== 'standard video') || itemCopy.type === 'videosity unit'">
				<mat-label class="mat-label">Select Course</mat-label>
				<mat-select [value]="itemCopy.courseid" (selectionChange)="changeCourseType($event.value)">
					<mat-option *ngFor="let course of videosityCourses" [value]="course.courseid">{{ course.name }}</mat-option>
				</mat-select>
			</div>
		</div>


		<div class="main-bottom-box">

			<!-- For download type -->

			<div class="download-content-box" *ngIf="itemCopy.type === 'download' || itemCopy.type === 'Download'">
				<h5>Upload Assets</h5>

				<div class="download-inner-box">
					<div class="left-box">
						<!-- <div class="image-box">
							<div class="title-upld-box">
								<div class="title">Portrait Image</div>
								<div class="img-upld-box">
									<input type="file" accept="image/*" (change)="chooseFileForUploading($event, 'download', 'image', 'portrait')" name="" id="">
									<img src="../../../../../../../assets/icons/Creation Centre Icons/Edit.png" alt="">
								</div>
							</div>

							<div class="upload-box">
								<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" *ngIf="!itemCopy.metadata.documents[0].portraitImage" style="height: 42px" alt="upload-icon">
								<img *ngIf="itemCopy.metadata.documents[0].portraitImage" style="height: 100%;" [src]="itemCopy.metadata.documents[0].portraitImage" />

								<div *ngIf="itemCopy.metadata.documents[0].portraitImage" class="delete-icon">
									<mat-icon (click)="removeImageFromUnit('download', 'portrait')">close</mat-icon>
								</div>
							</div>
						</div> -->

						<!-- <div class="image-box">
							<div class="title-upld-box">
								<div class="title">Landscape Image</div>
								<div class="img-upld-box">
									<input type="file" accept="image/*" (change)="chooseFileForUploading($event, 'download', 'image', 'landscape')" name="" id="">
									<img src="../../../../../../../assets/icons/Creation Centre Icons/Edit.png" alt="">
								</div>
							</div>

							<div class="upload-box">
								<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" *ngIf="!itemCopy.metadata.documents[0].landscapeImage" style="height: 42px" alt="upload-icon">
								<img *ngIf="itemCopy.metadata.documents[0].landscapeImage" style="height: 100%;" [src]="itemCopy.metadata.documents[0].landscapeImage" />

								<div *ngIf="itemCopy.metadata.documents[0].landscapeImage" class="delete-icon">
									<mat-icon (click)="removeImageFromUnit('download', 'landscape')">close</mat-icon>
								</div>
							</div>

						</div> -->

						<!-- Add Unit Image Section -->
						<div class="image-box">
							<div class="title-upld-box">
								<div class="title">Unit Thumbnail</div>
								<div *ngIf="(itemCopy.metadata.documents[0].landscapeImage || itemCopy.metadata.documents[0].portraitImage)" class="img-upld-box">
									<mat-icon (click)="removeImageFromUnit('download', itemCopy.metadata.documents[0]?.landscapeImage ? 'landscape' : 'portrait')">close</mat-icon>
								</div>
							</div>

							<div class="upload-box" [ngStyle]="{'padding-top': !(itemCopy.metadata.documents[0].landscapeImage || itemCopy.metadata.documents[0].portraitImage) ? '10px' : '0px'}">
								<ng-container *ngIf="!(itemCopy.metadata.documents[0].landscapeImage || itemCopy.metadata.documents[0].portraitImage); else unitImageElseBlock">
									<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 42px" alt="upload-icon">
									<div class="drag-drop-text">(You can also drag & drop!)</div>
									<input type="file" accept="image/png, image/jpeg" (change)="chooseFileForUploading($event, 'download', 'image', 'portrait')" name="" id="">
								</ng-container>

								<ng-template #unitImageElseBlock>
									<img style="height: 100%;" [src]="itemCopy.metadata.documents[0].portraitImage || itemCopy.metadata.documents[0].landscapeImage" />

									<!-- <div class="delete-icon">
										<mat-icon (click)="removeImageFromUnit('download', itemCopy.metadata.documents[0]?.landscapeImage ? 'landscape' : 'portrait')">close</mat-icon>
									</div> -->
								</ng-template>
							</div>
							<div class="limit-text">PNG or JPEG Required. Max size 1mb.</div>
						</div>
						<!-- Add Unit Image Section -->

						<div class="image-box">
							<!-- <mat-label class="mat-label">Download Url</mat-label>
							<input [(ngModel)]="itemCopy.metadata.documents[0].link" placeholder="Enter url manually or choose to upload a document here." matInput required>
							<button mat-button>
								Choose Document
								<input type="file" accept="application/pdf" (change)="chooseFileForUploading($event, 'download', 'file', '')" name="" id="">
							</button> -->

							<div class="title-upld-box">
								<div class="title">Unit Download</div>
								<div *ngIf="itemCopy.metadata.documents[0].link" class="img-upld-box">
									<mat-icon (click)="removeDocumentFromUnit('download', topicIndex)">close</mat-icon>
								</div>
							</div>

							<div class="upload-box" [ngStyle]="{'padding-top': !(itemCopy.metadata.documents[0].link || uploadProgress > 0) ? '10px' : '0px'}">
								<div *ngIf="(itemCopy.metadata.documents[0].link || uploadProgress > 0); else elseDownloadBlock" class="image-text-bx" (click)="openPdfModal(itemCopy.metadata.documents[0].link)">
									<p>Once document uploads, please click to view.</p>
									<img src="../../../../../../../assets/icons/doc-srch.png" alt="">
								</div>

								<ng-template #elseDownloadBlock>
									<div class="image-text-bx">
										<!-- <p>Once document uploads, please click to view.</p> -->
										<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 42px;margin-bottom: 15px;" alt="upload-icon">
										<input type="file" accept="application/pdf" (change)="chooseFileForUploading($event, 'download', 'file', '')" name="" id="">
									</div>
								</ng-template>


								<!-- <ng-container *ngIf="!itemCopy.metadata.documents[0].link">
									<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 42px" alt="upload-icon">
									<input type="file" accept="application/pdf" (change)="chooseFileForUploading($event, 'download', 'file', '')" name="" id="">
								</ng-container>

								<ng-container *ngIf="itemCopy.metadata.documents[0].link">
									<iframe [src]="sanitizePdfUrl(itemCopy.metadata.documents[0].link)" style="width:100%; height:100%;" frameborder="0"></iframe>
								</ng-container> -->

								<!-- <div *ngIf="itemCopy.metadata.documents[0].link" class="delete-icon">
									<mat-icon >close</mat-icon>
								</div> -->
							</div>
						</div>
					</div>
					<div class="right-box">
						<div class="progress-bar-box">
							<!-- <progress id="progressBar" [(value)]="uploadProgress" max="100"></progress> -->
							<div class="custom-progress-bar">
								<div [ngStyle]="{'width': uploadProgress + '%'}"></div>
							</div>
							<div class="progress-txt" *ngIf="uploadProgress >= 1">
								<p class="small-text" *ngIf="uploadProgress <= 99">{{ uploadProgress }}% uploaded</p>
								<p class="small-text" *ngIf="uploadProgress === 100">Upload completed</p>
							</div>

							<div class="progress-txt" *ngIf="uploadProgress <= 0">
								<p class="small-text">Download will commence uploading once file is selected</p>
							</div>
						</div>

						<!-- <input [(ngModel)]="itemCopy.metadata.documents[0].link" placeholder="Url for uploaded download comes up here." matInput required> -->
					</div>
				</div>
			</div>

			<!-- For new standard video type -->

			<div class="video-content-box" *ngIf="(itemCopy.type === 'video' || itemCopy.type === 'Video') && (itemCopy.videoType === 'standard video')">
				<!-- <mat-label class="mat-label unit-heading">Unit Topics</mat-label> -->
				<div *ngFor="let topic of itemCopy.metadata.topics; let topicIndex = index">
					<div class="topic-box">
						<h5>Upload Assets</h5>
						<!-- <div class="fl">
							<mat-label class="mat-label">{{ topicIndex + 1 }}. Unit Name</mat-label>
							<input [(ngModel)]="topic.name" matInput required>
						</div> -->

						<div class="topic-inner-box">
							<div class="left-box">
								<div class="image-box">
									<!-- <mat-label class="mat-label">Thumbnail Image</mat-label> -->

									<div class="title-upld-box">
										<div class="title">Unit Thumbnail</div>
										<div *ngIf="topic.thumbnailSource" class="img-upld-box">
											<mat-icon (click)="removeImageFromUnit('video', 'thumbnail', topicIndex)">close</mat-icon>
										</div>
									</div>

									 <div class="upload-box" [ngStyle]="{'padding-top': !topic.thumbnailSource ? '10px' : '0px'}">
										<ng-container *ngIf="!topic.thumbnailSource">
											<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 42px" alt="upload-icon">
											<div class="drag-drop-text">(You can also drag & drop!)</div>
											<input type="file" accept="image/png, image/jpeg" (change)="chooseFileForUploading($event, 'video', 'image', 'thumbnail', topicIndex)" />
										</ng-container>

										<img *ngIf="topic.thumbnailSource" style="height: 100%;" [src]="topic.thumbnailSource" />

										<!-- <div *ngIf="topic.thumbnailSource" class="delete-icon">
											<mat-icon (click)="removeImageFromUnit('video', 'thumbnail', topicIndex)">close</mat-icon>
										</div> -->
									</div>

									<div class="limit-text">PNG or JPEG Required. Max size 1mb.</div>

									<!-- <div *ngIf="topic.thumbnailSource" class="img-container">
										<img class="video-unit-thumbnail" [src]="topic.thumbnailSource">
										<div class="remove-image-icon">
											<mat-icon (click)="removeImageFromUnit('video', 'thumbnail', topicIndex)">close</mat-icon>
										</div>
									</div>
									<button *ngIf="!topic.thumbnailSource" mat-button>
										Choose Image
										<input type="file" accept="image/*" (change)="chooseFileForUploading($event, 'video', 'image', 'thumbnail', topicIndex)" name="" id="">
									</button>
									<button class="remove-topic-btn" mat-button (click)="removeTopicFromUnit(topicIndex)">Remove Topic</button> -->
								</div>

								<div class="video-box">

									<div class="title-upld-box">
										<div class="title">Unit Video</div>
										<div *ngIf="topic.videoLocation" class="img-upld-box">
											<mat-icon (click)="removeVideoFromUnit('video', topicIndex)">close</mat-icon>
										</div>
									</div>

									 <div class="upload-box" [ngStyle]="{'padding-top': !topic.videoLocation ? '10px' : '0px'}">
										<ng-container *ngIf="!topic.videoLocation">
											<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 42px;margin-bottom: 11px;" alt="upload-icon">
											<input type="file" accept="video/*" (change)="chooseFileForUploading($event, 'video', 'video', '', topicIndex)" />
										</ng-container>

										<video *ngIf="topic.videoLocation" style="height: 100%; max-width: 100%;" [src]="topic.videoLocation"></video>

										<!-- <div *ngIf="topic.videoLocation" class="delete-icon">
											<mat-icon (click)="removeVideoFromUnit('video', 'thumbnail', topicIndex)">close</mat-icon>
										</div> -->
									</div>

									<!--
									<mat-label class="mat-label">Video Url</mat-label>
									<input [(ngModel)]="topic.videoLocation" placeholder="Url for uploaded video comes up here." matInput required>
									<button mat-button>
										Choose Video
										<input type="file" accept="video/*" (change)="chooseFileForUploading($event, 'video', 'video', '', topicIndex)" name="" id="">
									</button> -->
								</div>
							</div>

							<div class="right-box">
								<div class="progress-bar-box">
									<!-- <progress id="progressBar" [(value)]="uploadProgress" max="100"></progress> -->
									<div class="custom-progress-bar">
										<div [ngStyle]="{'width': uploadProgress + '%'}"></div>
									</div>
									<div class="progress-txt" *ngIf="uploadProgress >= 1">
										<p class="small-text" *ngIf="uploadProgress <= 99">{{ uploadProgress }}% uploaded</p>
										<p class="small-text" *ngIf="uploadProgress === 100">Upload completed</p>
									</div>

									<div class="progress-txt" *ngIf="uploadProgress <= 0">
										<p class="small-text">Video will commence uploading once file is selected</p>
									</div>
								</div>

								<!-- <input [(ngModel)]="topic.videoLocation" placeholder="Url for uploaded video comes up here." matInput required> -->
							</div>
						</div>

						<!-- <p class="small-text">Video will get uploaded once you choose the file in your system.</p> -->

					</div>
				</div>
				<!-- <button class="add-topic-btn" mat-button (click)="addTopicToUnit()">Add Topic</button> -->
			</div>

			<!-- for ispring quiz  -->
			<div class="video-content-box" *ngIf="itemCopy.quizType === 'ispring quiz'">
				<div class="topic-box" style="padding-bottom: 10px;">
					<h5>Upload Assets</h5>

					<div class="topic-inner-box">
						<div class="left-box">
							<div class="image-box">
								<div class="title-upld-box">
									<div class="title">New Quiz Template</div>
									<div *ngIf="itemCopy.sourcePptFile" class="img-upld-box">
										<mat-icon (click)="removeQuizHandler('sourcePptFile')">close</mat-icon>
									</div>
								</div>

								<div class="upload-box">
									<ng-container *ngIf="!itemCopy.sourcePptFile">
										<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png"
											class="upload-icon" style="height: 42px;" alt="PowerPoint Upload Icon" />
										<input type="file"

											(change)="quizFileUploadHandler($event, 'sourcePptFile')" />
										<div class="drag-drop-text">(You can also drag & drop!)</div>
									</ng-container>

									<div *ngIf="itemCopy.sourcePptFile" class="file-preview">
										<a [href]="itemCopy.sourcePptFile" target="_blank" download class="file-link">
											<img src="../../../../../../../assets/images/power-point.png"
											style="height: 50px; margin-right: 8px;" alt="PPT Icon" />
										</a>
									</div>
								</div>
								<!-- <div class="limit-text" style="font-size: 10px;">.pptx Required.</div> -->
							</div>

							<div class="image-box">
								<div class="title-upld-box">
									<div class="title">Bulk Question Uploader</div>
									<div *ngIf="itemCopy.questionsZipFile" class="img-upld-box">
										<mat-icon (click)="removeQuizHandler('questionsZipFile')">close</mat-icon>
									</div>
								</div>

								<div class="upload-box">
									<ng-container *ngIf="!itemCopy.questionsZipFile">
										<img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon"
											style="height: 42px;" alt="Excel Upload Icon" />
										<input type="file" accept=".zip,application/zip"
											(change)="quizFileUploadHandler($event, 'questionsZipFile')" />
										<div class="drag-drop-text">(You can also drag & drop!)</div>
									</ng-container>

									<div *ngIf="itemCopy.questionsZipFile" class="file-preview">
										<a [href]="itemCopy.questionsZipFile" target="_blank" download
											class="file-link">
											<img src="../../../../../../../assets/images/excel.png"
											style="height: 50px; margin-right: 8px;" alt="ZIP Icon" />
										</a>
									</div>
								</div>
								<div class="limit-text" style="font-size: 10px;">.zip Required.</div>
							</div>
						</div>

						<div class="right-box" style="padding-bottom: -5px;">
							<div style="padding-bottom: 10px;text-align: center ;">
								<p *ngIf="itemCopy.quizDeployment === 'processing'" style="margin: 0;font-size: 13px;font-weight: 500;">Quiz is being processed...</p>
								<p *ngIf="itemCopy.quizDeployment === 'failed'" style="margin: 0;font-size: 13px;font-weight: 500;">Quiz deployment failed!</p>
								<p *ngIf="itemCopy.quizDeployment === 'success'" style="margin: 0;font-size: 13px;font-weight: 500;">Quiz deployed successfully</p>
								<a [href]="itemCopy.quizUrl" target="_blank">
									<button id="preview-btn" [disabled]="!itemCopy.quizUrl">Preview</button>
								</a>
							</div>
							<div class="progress-bar-box">
								<div class="custom-progress-bar">
									<div [ngStyle]="{'width': uploadProgress + '%'}"></div>
								</div>
								<div class="progress-txt" *ngIf="uploadProgress >= 1">
									<p class="small-text" *ngIf="uploadProgress <= 99">{{ uploadProgress }}% uploaded</p>
									<p class="small-text" *ngIf="uploadProgress === 100">Upload completed</p>
								</div>

								<div class="progress-txt" *ngIf="uploadProgress <= 0">
									<p class="small-text">Quiz will commence uploading once file is selected</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<div mat-dialog-actions id="buttons-row">
	<button id="cancel-btn" mat-button mat-dialog-close (click)="closeModal('cancel')">Cancel</button>
	<button id="save-btn" mat-button (click)="closeModal('save')">Save</button>
</div>